import React from "react";
import { Handle } from "@xyflow/react";

const CustomNode = ({ data, isConnectable, id }) => {
    const isExternal = data?.isExternal ? true : false;
    const isDebugging = data?.debug ? data.debug : false;
    const isSource = data?.source ? true : false;
    const isTarget = data?.target ? true : false;
    const primaryColor = "#CC2B52";
    const secondaryColor = "#FCF596";
    return (
        <>
            {isSource && Object.entries(data?.source).map(([key, value]) => <Handle
                key={id+key}
                id={id+key}
                type="source"
                position={value}
                isConnectable={isConnectable}
            />)}
            <div
                style={{
                    width: "140px",
                    padding: "10px",
                    border: "1px solid #ddd",
                    borderRadius: "5px",
                    background: isExternal ? "white" : primaryColor,
                    textAlign: "center",
                    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                }}
            >
                <strong>{data.label}</strong>
                <p style={{ fontSize: "12px", color: isExternal ? "gray" : 'white', margin: "5px 0 0" }}>
                    {data.description}
                </p>
                {isDebugging && <p style={{ fontSize: "6px", color: "#000000"}}>
                    <b>ID</b> <span style={{ color: secondaryColor }}>{id}</span> |
                    <b>External</b> <span style={{ color: secondaryColor }}>{isExternal ? 'Yes' : 'No'}</span> |
                    <b>Source</b> <span style={{ color: secondaryColor }}>{data?.source?.length}</span> |
                    <b>Target</b> <span style={{ color: secondaryColor }}>{data?.target?.length}</span>
                </p>}
            </div>
            {isTarget && Object.entries(data?.target).map(([key, value]) => <Handle
                key={id+key}
                id={id+key}
                type="target"
                position={value}
                isConnectable={isConnectable}
            />)}
        </>
    )
}

export default CustomNode